export default __webpack_public_path__ + "static/media/CARLO.26f53607.png";